import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../../utils/axios";
import EntityManagement from "../../components/formTemplates/EntityManagement";
import EntityTable from "../../components/templateComponents/EntityTable";
import {
  entitiesConfig,
  staticPhoneExtensions,
} from "../../components/templateComponents/constants";

const Merchants = () => {
  const entityConfig = entitiesConfig.merchants;

  const [formData, setFormData] = useState(() => {
    const initialData = {
      csc_id: 1,
      csc_name: "India",
      phone_extension: "+91",
      primary_phone: "",
      merchant_email: "",
      name: "",
      description: "",
    };
    entityConfig.formFields.forEach((field) => {
      if (!(field.name in initialData)) {
        initialData[field.name] = field.defaultValue || "";
      }
    });
    return initialData;
  });

  const [formErrors, setFormErrors] = useState({});
  const [entities, setEntities] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editingEntityId, setEditingEntityId] = useState(null);
  const [isTableModalOpen, setIsTableModalOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const firstFormFieldRef = useRef(null);

  const dropdownData = {
    phone_extension: staticPhoneExtensions,
  };

  const fetchEntities = async () => {
    try {
      const response = await axiosInstance.post(entityConfig.endpoints.fetch, {
        view_type: "view all",
      });
      const fetchedEntities = response.data.message.map((entity) => ({
        ...entity,
        csc_name: entity.csc_id === 1 ? "India" : entity.csc_name,
      }));
      setEntities(fetchedEntities);
    } catch (error) {
      console.error("Error fetching merchants:", error);
    }
  };

  useEffect(() => {
    fetchEntities();
  }, []);

  const validatePhone = (phone) => /^[0-9]{10}$/.test(phone);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const errors = {};

    if (!validatePhone(formData.primary_phone)) {
      errors.primary_phone = "Phone number must be exactly 10 digits.";
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    } else {
      setFormErrors({});
    }

    const payload = {
      name: formData.name,
      csc_id: 1,
      description: formData.description,
      phone_extension: formData.phone_extension,
      primary_phone: formData.primary_phone,
      merchant_email: formData.merchant_email,
    };

    try {
      if (editMode) {
        await axiosInstance.post(entityConfig.endpoints.update, {
          merchant_id: editingEntityId,
          ...payload,
        });
        setSuccessMessage("Merchant updated successfully!");
      } else {
        await axiosInstance.post(entityConfig.endpoints.create, payload);
        setSuccessMessage("Merchant added successfully!");
      }

      await fetchEntities();
      resetForm();
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (error) {
      console.error("Error saving merchant:", error);
    }
  };

  const handleEdit = (entityId) => {
    const entityToEdit = entities.find((e) => e.merchant_id === entityId);
    if (entityToEdit) {
      setFormData({
        ...entityToEdit,
        csc_id: 1,
        csc_name: "India",
      });
      setEditMode(true);
      setEditingEntityId(entityId);
      setIsTableModalOpen(false);
      if (firstFormFieldRef.current) firstFormFieldRef.current.focus();
    }
  };

  const handleUpdate = async (entityId, updatedData) => {
    try {
      const response = await axiosInstance.post(entityConfig.endpoints.update, {
        merchant_id: entityId,
        ...updatedData,
      });

      if (response.data.status === "success") {
        await fetchEntities();
        resetForm();
        setIsTableModalOpen(false);
        setSuccessMessage("Merchant updated successfully!");
        setTimeout(() => setSuccessMessage(""), 3000);
      } else {
        console.error("Failed to update merchant:", response.data);
      }
    } catch (error) {
      console.error("Error updating merchant:", error);
    }
  };

  const resetForm = () => {
    setFormData(() => {
      const initialData = {
        csc_id: 1,
        csc_name: "India",
        phone_extension: "+91",
        primary_phone: "",
        merchant_email: "",
        name: "",
        description: "",
      };
      entityConfig.formFields.forEach((field) => {
        if (!(field.name in initialData)) {
          initialData[field.name] = field.defaultValue || "";
        }
      });
      return initialData;
    });
    setEditMode(false);
    setEditingEntityId(null);
    setFormErrors({});
  };

  return (
    <div className="merchants">
      <EntityManagement
        entityName={entityConfig.name}
        formFields={entityConfig.formFields}
        formData={formData}
        setFormData={setFormData}
        handleFormSubmit={handleFormSubmit}
        dropdownData={dropdownData}
        formErrors={formErrors}
        showWorkdays={false}
        handleViewTableClick={() => setIsTableModalOpen(true)}
        firstFormFieldRef={firstFormFieldRef}
        successMessage={successMessage}
      />

      {isTableModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <button onClick={() => setIsTableModalOpen(false)}>Close</button>
            <EntityTable
              data={entities}
              columns={entityConfig.columns}
              onEdit={handleEdit}
              keyField="merchant_id"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Merchants;
